// src/components/quizzes/Bonus9TimeTables.js
//
// Times-table bonus round for the 9s: a problem at the top, catch the answers.
// Runs on the shared bonus-round engine (kit/BonusShell.js) — the
// BonusDiamonds look, bombs, bonus stars, clocks, combos, a new question
// every few right answers, and 🏁 End game. Same contract as before:
// BonusRouter renders <ThisGame onBonusComplete questions placeholderImage />.

import React from "react";
import BonusShell from "./kit/BonusShell";

// Your exact problem list (includes duplicate 2x3, excludes 2x4), plus reversed forms.
// Use the full 0–10 set, keep the duplicate on 3 only if you want extra weight
const PROBLEMS = [
  { a: 9, b: 0 }, { a: 9, b: 1 }, { a: 9, b: 2 }, { a: 9, b: 3 },
  { a: 9, b: 3 }, // duplicate on purpose
  { a: 9, b: 4 }, { a: 9, b: 5 }, { a: 9, b: 6 }, { a: 9, b: 7 },
  { a: 9, b: 8 }, { a: 9, b: 9 }, { a: 9, b: 10 },
  { a: 10, b: 9 }, { a: 9, b: 9 }, { a: 8, b: 9 }, { a: 7, b: 9 },
  { a: 6, b: 9 }, { a: 5, b: 9 }, { a: 4, b: 9 }, { a: 3, b: 9 },
  { a: 2, b: 9 }, { a: 1, b: 9 }, { a: 0, b: 9 },
];

const randomDistractor = (target) => {
  const pool = [];
  for (let v = 0; v <= 144; v++) {
    if (v !== target) pool.push(v);
  }
  const nearby = pool.filter(v => Math.abs(v - target) <= 10);
  const src = nearby.length >= 6 ? nearby : pool;
  return src[Math.floor(Math.random() * src.length)];
};

const pickProblem = (prev) => {
  let c = PROBLEMS[Math.floor(Math.random() * PROBLEMS.length)];
  for (let i = 0; i < 8 && prev && c.a === prev.a && c.b === prev.b; i += 1) c = PROBLEMS[Math.floor(Math.random() * PROBLEMS.length)];
  return c;
};

const TimesTableBonus = (props) => (
  <BonusShell
    {...props}
    title="Times Tables Bonus!"
    emoji="✖️"
    sub="Solve the problem at the top — then catch every right answer!"
    intro="Look at the multiplication problem at the top and catch the right answers. Each one is worth five points. Watch out for bombs! Catch stars for bonus points and clocks for more time. Press Start when you are ready."
    rules={[
      { icon: "✅", text: "Right answer", pts: "+5" },
      { icon: "❌", text: "Wrong answer", pts: "-1" },
    ]}
    init={pickProblem}
    prompt={(p) => ({ big: `${p.a} × ${p.b} = ?`, small: "Catch the answer!", say: `${p.a} times ${p.b}.` })}
    spawn={(p, onScreen) => {
      const ans = p.a * p.b;
      // at least two right answers falling; after that about 1 in 3
      return onScreen.filter((x) => x.value === ans).length < 2 || Math.random() < 0.3 ? ans : randomDistractor(ans);
    }}
    check={(p, v) => v === p.a * p.b}
    newEvery={3}
  />
);

export default TimesTableBonus;
